<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="礼品卡名称：" prop="cardName">
            <el-input style="width: 424px;" v-model="ruleForm.cardName" placeholder="请输入礼品卡名称"></el-input>
          </el-form-item>
          <el-form-item label="图片：" prop="thumb">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="fileList"
              :on-remove="delImgBtn.bind(null,{'type':1})"
              :on-success="uploadImgBtn.bind(null,{'type':1})">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="商品相册 ：" prop="pictureList">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="9"
              :file-list="pictureList"
              :on-remove="delImgBtn.bind(null,{'type':2})"
              :on-success="uploadImgBtn.bind(null,{'type':2})">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：800*800px，最多9张，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item label="售价：" prop="salePrice">
            <el-input style="width: 424px;" v-model="ruleForm.salePrice" placeholder="请输入售价"></el-input>
          </el-form-item>
          <el-form-item label="面额：" prop="faceValuePrice">
            <el-input style="width: 424px;" v-model="ruleForm.faceValuePrice" placeholder="请输入面额" :disabled="dataId != '' ? true : false"></el-input>
          </el-form-item>
          <el-form-item label="库存：" prop="stockNum">
            <el-input style="width: 424px;" v-model="ruleForm.stockNum" placeholder="请输入库存" :disabled="dataId != '' ? true : false"></el-input>
          </el-form-item>
          <el-form-item label="详情：" prop="cardDetail">
            <editor :value="ruleForm.cardDetail" :height="264" v-model="ruleForm.cardDetail"></editor>
          </el-form-item>
          <el-form-item label="是否开启：" prop="status">
            <el-switch
              v-model="ruleForm.status"
              active-color="#1890FF"
              inactive-color="#CCCCCC">
            </el-switch>
          </el-form-item>
          <el-form-item label="排序：" prop="sort">
            <el-input style="width: 424px;" v-model="ruleForm.sort" placeholder="请输入排序（默认 1 ）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { saveGiftCard, fetchGiftCardDetailById, updateGiftCard } from '@/api/giftCard'
import Editor from '@/components/Editor.vue'
export default {
  name: 'GiftCardAdd',
  components: {
    Editor
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      dataId: this.$route.query.dataId,
      fileList: [],
      ruleForm: {
        cardName: '',
        thumb: '',
        pictureList:[],
        salePrice: '',
        faceValuePrice: '',
        stockNum: '',
        cardDetail:'',
        sort: '',
        status: false
      },
      rules: {
        cardName: [
          { required: true, message: '请输入礼品卡名称', trigger: 'blur' }
        ],
        thumb: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ],
        pictureList: [
          { required: true, message: '请上传相册', trigger: 'blur' }
        ],
        salePrice: [
          { required: true, message: '请输入售价', trigger: 'blur' }
        ],
        faceValuePrice: [
          { required: true, message: '请输入面额', trigger: 'blur' }
        ],
        stockNum: [
          { required: true, message: '请输入库存', trigger: 'blur' }
        ]
      },
      pictureList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if (this.$route.query.dataId === undefined || this.$route.query.dataId === 'undefined') {
      this.dataId = ''
    } else {
      let that = this
      fetchGiftCardDetailById({ id: that.dataId }).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.ruleForm.cardName = data.cardName
          let status = false
          if (data.status === 1) {
            status = true
          }
          that.ruleForm.status = status
          that.ruleForm.sort = data.sort
          that.ruleForm.thumb = data.thumb
          that.fileList.push({url: data.thumb})
          that.ruleForm.pictureList = data.cardPictureList
          // 商品相册
          data.cardPictureList.forEach(function(item){
            that.pictureList.push({url: item});
          });
          that.ruleForm.salePrice = data.salePrice
          that.ruleForm.faceValuePrice = data.faceValuePrice
          that.ruleForm.stockNum = data.stockNum
          that.ruleForm.cardDetail = data.cardDetail
        }
      })
    }
  },
  methods: {
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 上传图片
    uploadImgBtn (obj,file) {
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 图片
          that.ruleForm.thumb = file.data.fileUrl;
          break;
        case 2:
          // 商品相册
          that.ruleForm.pictureList.push(file.data.fileUrl);
          break;
      }
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 图片
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.ruleForm.thumb = thumb;
          break;
        case 2:
          // 商品相册
          var pictureList = [];
          fileList.forEach(function(item){
            pictureList.push(item.url);
          });
          that.ruleForm.pictureList = pictureList;
          break;
      }
    },
    // 保存操作
    saveBtn () {
      let that = this
      let dataId = that.dataId
      let cardName = that.ruleForm.cardName
      let thumb = that.ruleForm.thumb
      let pictureList = that.ruleForm.pictureList
      let salePrice = that.ruleForm.salePrice
      let faceValuePrice = that.ruleForm.faceValuePrice
      let stockNum = that.ruleForm.stockNum
      let cardDetail = that.ruleForm.cardDetail
      let status = that.ruleForm.status ? 1 : 0
      let sort = that.ruleForm.sort === '' ? 1 : that.ruleForm.sort
      if (cardName === '') {
        this.$message.error('请输入礼品卡名称')
        return false
      }
      if (thumb === '') {
        this.$message.error('请上传图片')
        return false
      }
      if (pictureList.length === 0) {
        this.$message.error('请上传相册')
        return false
      }
      if (salePrice === '') {
        this.$message.error('请输入售价')
        return false
      }
      if (faceValuePrice === '') {
        this.$message.error('请输入面额')
        return false
      }
      if (stockNum === '') {
        this.$message.error('请输入库存')
        return false
      }
      let passData = {
        cardName: cardName, thumb: thumb, status: status, cardPictureList: pictureList, salePrice: salePrice, faceValuePrice: faceValuePrice, stockNum: stockNum, cardDetail: cardDetail, sort: sort
      }
      if (dataId !== '') {
        passData = {
          id: dataId, cardName: cardName, thumb: thumb, status: status, cardPictureList: pictureList, salePrice: salePrice, faceValuePrice: faceValuePrice, stockNum: stockNum, cardDetail: cardDetail, sort: sort
        }
        updateGiftCard(passData).then((res) => {
          that.backDataFun(res)
        })
      }else{
        saveGiftCard(passData).then((res) => {
         that.backDataFun(res)
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/giftCard/GiftCardAdd.vue